module.exports = __webpack_public_path__ + "static/media/step1.62d23eb9.svg";